export const Country = {
    All: "all",
    Thailand: "th",
    Philippines: "ph",
    Myanmar: "mm",
    Laos: "la"
};
